import React from 'react';
import { PropTypes } from 'prop-types';

import SearchFilters from './search-filters';
import SearchMeta from 'app/utility/search-meta';
import SearchPager from 'app/utility/search-pager';
import NewIncentive from './new-incentive';
import ProviderIncentiveCostTable from './provider-incentive-cost-table';

const PER_PAGE = 10;
class ProviderIncentiveCostSearch extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }

  render() {
    const setPage = page => {
      this.context.applySearchFilter({ page });
    };
    const { data, page, total_entries } = this.props.providerIncentiveCosts;
    const { loading } = this.props;

    return (
      <div className="provider-incentive-cost-root">
        <div>
          <SearchFilters />
          <hr />
          <NewIncentive />
        </div>
        <div className="display-area">
          <SearchMeta totalEntries={total_entries} returned={data.length} loading={loading} />
          <SearchPager
            page={page}
            totalEntries={total_entries}
            setPage={setPage.bind(this)}
            perPage={PER_PAGE}
          />
          <ProviderIncentiveCostTable data={data} />
          <SearchPager
            page={page}
            totalEntries={total_entries}
            setPage={setPage.bind(this)}
            perPage={PER_PAGE}
          />
        </div>
      </div>
    );
  }
}
ProviderIncentiveCostSearch.contextTypes = {
  applySearchFilter: PropTypes.func
};

export default ProviderIncentiveCostSearch;
